var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { withPaymentBotToken } from "./recaptcha";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { RadixLoading } from "../primitives/RadixLoading";
import { useCreditPaymentContext } from "./CreditPaymentContext";
import { PaymentErrorNotice } from "./PaymentErrorNotice";
import { AVSCollectionDetails } from "../avsCollection";
import client from "../../http/client";
import { useUI } from "../../providers";
import { PaymentForm } from "../paymentForm";
import { getDisplayedOrderTotal } from "../utility/cartTotals";
import { getXplorPayDebitFeeDescriptor } from "../utility/xplorPayDebitFeeDescriptor";
var XPLORPAY_SDK_SCRIPT_ID = "xplorpay-clearent-host-sdk";
var XPLORPAY_FORM_ID = "xplorpay_payment_form";
var XPLORPAY_PAYMENT_FORM_ID = "xplorpay_payment_fields";
var getXplorPayPublicKey = function (processorInfo) {
    var directPublicKey = processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.public_key;
    if (typeof directPublicKey === "string" && directPublicKey.trim().length > 0) {
        return directPublicKey.trim();
    }
    var transactionInfo = processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.transactionInfo;
    if (transactionInfo && typeof transactionInfo === "object") {
        var transactionPublicKey = transactionInfo.public_key;
        if (typeof transactionPublicKey === "string" && transactionPublicKey.trim().length > 0) {
            return transactionPublicKey.trim();
        }
    }
    return "";
};
var getXplorPayJwt = function (result) {
    var _a, _b;
    var jwt = (_b = (_a = result.payload) === null || _a === void 0 ? void 0 : _a["mobile-jwt"]) === null || _b === void 0 ? void 0 : _b.jwt;
    return typeof jwt === "string" ? jwt : "";
};
var getXplorPayTokenPayload = function (value) {
    if (value && typeof value === "object") {
        return value;
    }
    if (typeof value !== "string" || value.trim().length === 0) {
        return null;
    }
    try {
        var parsedValue = JSON.parse(value);
        return parsedValue && typeof parsedValue === "object"
            ? parsedValue
            : null;
    }
    catch (_error) {
        return null;
    }
};
var loadXplorPaySdk = function (scriptUrl) {
    return new Promise(function (resolve, reject) {
        if (window.ClearentSDK) {
            resolve();
            return;
        }
        var existingScript = document.getElementById(XPLORPAY_SDK_SCRIPT_ID);
        if (existingScript) {
            existingScript.addEventListener("load", function () { return resolve(); }, { once: true });
            existingScript.addEventListener("error", function () { return reject(new Error("Unable to load the payment form.")); }, { once: true });
            return;
        }
        var script = document.createElement("script");
        script.id = XPLORPAY_SDK_SCRIPT_ID;
        script.src = scriptUrl;
        script.async = true;
        script.onload = function () { return resolve(); };
        script.onerror = function () { return reject(new Error("Unable to load the payment form.")); };
        document.body.appendChild(script);
    });
};
export var XplorPayPaymentForm = function () {
    var _a, _b;
    var _c = useCreditPaymentContext(), cart = _c.cart, processorInfo = _c.processorInfo, paymentError = _c.paymentError, reportProcessorError = _c.reportProcessorError, clearPaymentError = _c.clearPaymentError, markPaymentSubmitting = _c.markPaymentSubmitting, isAvsValid = _c.isAvsValid, billingInfo = _c.billingInfo, tip = _c.tip, checkoutAddressId = _c.checkoutAddressId, checkoutUserId = _c.checkoutUserId, checkoutComment = _c.checkoutComment, isCurbsideOrder = _c.isCurbsideOrder, shouldSendSmsAlerts = _c.shouldSendSmsAlerts, hasMarketingOptIn = _c.hasMarketingOptIn, smsNumber = _c.smsNumber, signUpRewards = _c.signUpRewards, handleCreditOrderComplete = _c.handleCreditOrderComplete;
    var _d = useUI(), storeId = _d.storeId, storeName = _d.storeName, storeSupportsApplePay = _d.storeSupportsApplePay, storeSupportsGooglePay = _d.storeSupportsGooglePay;
    var _e = useState(true), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), isSubmitting = _f[0], setIsSubmitting = _f[1];
    var _g = useState(false), avsRequiredMessageVisible = _g[0], setAvsRequiredMessageVisible = _g[1];
    var _h = useState(false), shouldSaveCard = _h[0], setShouldSaveCard = _h[1];
    var orderSubmissionStartedRef = useRef(false);
    var manualTokenRequestPendingRef = useRef(false);
    var processPaymentTokenRef = useRef(null);
    var publicKey = useMemo(function () { return getXplorPayPublicKey(processorInfo); }, [processorInfo]);
    var baseUrl = typeof (processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.base_url) === "string" ? processorInfo.base_url.trim() : "";
    var sdkScriptUrl = typeof (processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.sdk_script_url) === "string" ? processorInfo.sdk_script_url.trim() : "";
    var sessionNcaTitle = (_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.nca_title;
    var avsIncomplete = !isAvsValid;
    var walletAmount = useMemo(function () {
        if (!cart) {
            return "0.00";
        }
        return getDisplayedOrderTotal({
            total: cart.total,
            delivery_tip: tip,
            nca_fee: cart.nca_fee,
        }, true).toFixed(2);
    }, [cart, tip]);
    var walletMerchantLabel = storeName || (storeId !== null ? "Store ".concat(storeId) : "Online order");
    var hasPayableWalletAmount = Number(walletAmount) > 0;
    var enableApplePay = storeSupportsApplePay && hasPayableWalletAmount;
    var enableGooglePay = storeSupportsGooglePay && hasPayableWalletAmount;
    var processPaymentToken = useCallback(function (result, shouldCreateToken) { return __awaiter(void 0, void 0, void 0, function () {
        var zipCodeField, mobileJwt, shouldReleaseSubmitting, response, orderPayload, order, error_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (orderSubmissionStartedRef.current) {
                        return [2 /*return*/];
                    }
                    clearPaymentError();
                    if (avsIncomplete) {
                        setAvsRequiredMessageVisible(true);
                        setIsSubmitting(false);
                        markPaymentSubmitting(false);
                        zipCodeField = document.getElementById("avsZipCode");
                        if (zipCodeField) {
                            zipCodeField.focus();
                        }
                        return [2 /*return*/];
                    }
                    mobileJwt = getXplorPayJwt(result);
                    if (!mobileJwt) {
                        reportProcessorError("xplorpay", {
                            code: "xplorpay_missing_mobile_jwt",
                            message: "The payment processor did not return a valid payment token. Please verify your payment details and try again.",
                        });
                        setIsSubmitting(false);
                        markPaymentSubmitting(false);
                        return [2 /*return*/];
                    }
                    orderSubmissionStartedRef.current = true;
                    setIsSubmitting(true);
                    markPaymentSubmitting(true);
                    shouldReleaseSubmitting = true;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, withPaymentBotToken(__assign({ mobileJwt: mobileJwt, exp_date: (_b = (_a = result.payload) === null || _a === void 0 ? void 0 : _a["mobile-jwt"]) === null || _b === void 0 ? void 0 : _b["exp-date"], address: billingInfo.billingAddress, zip: billingInfo.billingZipcode, tip_amount: Number(tip) || 0, address_id: checkoutAddressId, user_id: checkoutUserId, comment: checkoutComment, is_curbside_order: isCurbsideOrder, should_send_sms_alerts: shouldSendSmsAlerts, sms_number: smsNumber, has_marketing_opt_in: hasMarketingOptIn, shouldCreateToken: shouldCreateToken }, (signUpRewards ? { sign_up_rewards: true } : {}))).then(function (paymentData) { return client.post("/order/xplorpay", paymentData); })];
                case 2:
                    response = _e.sent();
                    if (response.status === 200) {
                        shouldReleaseSubmitting = false;
                        orderPayload = (_c = response.data) === null || _c === void 0 ? void 0 : _c.order_data;
                        order = typeof orderPayload === "string" ? JSON.parse(orderPayload) : (_d = response.data) === null || _d === void 0 ? void 0 : _d.order;
                        handleCreditOrderComplete(order);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _e.sent();
                    reportProcessorError("xplorpay", error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    if (shouldReleaseSubmitting) {
                        orderSubmissionStartedRef.current = false;
                        markPaymentSubmitting(false);
                    }
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        avsIncomplete,
        billingInfo.billingAddress,
        billingInfo.billingZipcode,
        checkoutAddressId,
        checkoutComment,
        checkoutUserId,
        clearPaymentError,
        handleCreditOrderComplete,
        hasMarketingOptIn,
        isCurbsideOrder,
        markPaymentSubmitting,
        reportProcessorError,
        shouldSendSmsAlerts,
        signUpRewards,
        smsNumber,
        tip,
    ]);
    useEffect(function () {
        processPaymentTokenRef.current = processPaymentToken;
    }, [processPaymentToken]);
    useEffect(function () {
        var cancelled = false;
        var initialized = false;
        var previousTokenSuccess = window.ClearentTokenSuccess;
        var previousTokenError = window.ClearentTokenError;
        var handleTokenSuccess = function (raw, json) {
            var _a, _b;
            if (manualTokenRequestPendingRef.current) {
                return;
            }
            var tokenPayload = (_a = getXplorPayTokenPayload(json)) !== null && _a !== void 0 ? _a : getXplorPayTokenPayload(raw);
            if (!tokenPayload) {
                reportProcessorError("xplorpay", {
                    code: "xplorpay_invalid_token_response",
                    message: "The payment processor returned an invalid payment response. Please try again.",
                });
                return;
            }
            // Digital wallet tokens cannot be stored for future recurring payments.
            void ((_b = processPaymentTokenRef.current) === null || _b === void 0 ? void 0 : _b.call(processPaymentTokenRef, tokenPayload, false));
        };
        var handleTokenError = function () {
            if (manualTokenRequestPendingRef.current) {
                return;
            }
            orderSubmissionStartedRef.current = false;
            setIsSubmitting(false);
            markPaymentSubmitting(false);
            reportProcessorError("xplorpay", {
                code: "xplorpay_token_error",
                message: "The payment processor could not verify this payment method. Please try again.",
            });
        };
        window.ClearentTokenSuccess = handleTokenSuccess;
        window.ClearentTokenError = handleTokenError;
        var initializePaymentForm = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        clearPaymentError();
                        if (!publicKey) {
                            reportProcessorError("xplorpay", {
                                code: "xplorpay_missing_public_key",
                                message: "This store is missing payment credentials. Please contact the store to complete payment.",
                            });
                            setIsLoading(false);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        if (!baseUrl || !sdkScriptUrl) {
                            reportProcessorError("xplorpay", {
                                code: "xplorpay_missing_sdk_configuration",
                                message: "The payment form is unavailable. Please contact the store to complete payment.",
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, loadXplorPaySdk(sdkScriptUrl)];
                    case 2:
                        _a.sent();
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        if (!window.ClearentSDK) {
                            reportProcessorError("xplorpay", {
                                code: "xplorpay_sdk_unavailable",
                                message: "The payment form is unavailable. Please refresh the page and try again.",
                            });
                            return [2 /*return*/];
                        }
                        // The current SDK handles wallet availability inside its iframe;
                        // it no longer exposes the legacy googlePayAvailable method.
                        window.ClearentSDK.init(__assign(__assign({ baseUrl: baseUrl, pk: publicKey, paymentFormId: XPLORPAY_PAYMENT_FORM_ID, cardPlaceholder: "Card number", expDatePlaceholder: "MM / YY", cvcPlaceholder: "Security code" }, (enableApplePay ? {
                            enableApplePay: true,
                            applePayRequest: {
                                total: {
                                    label: walletMerchantLabel,
                                    amount: walletAmount,
                                    type: "final",
                                },
                            },
                        } : {})), (enableGooglePay ? {
                            enableGooglePay: true,
                            googlePayRequest: {
                                total: {
                                    label: walletMerchantLabel,
                                    amount: walletAmount,
                                    type: "final",
                                },
                            },
                            googlePayButtonConfig: {
                                buttonColor: "default",
                                buttonType: "pay",
                                buttonLocale: "en",
                                buttonSizeMode: "fill",
                            },
                        } : {})));
                        initialized = true;
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        if (!cancelled) {
                            reportProcessorError("xplorpay", {
                                code: "xplorpay_sdk_load_error",
                                message: "Unable to load the payment form.",
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (!cancelled) {
                            setIsLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void initializePaymentForm();
        return function () {
            cancelled = true;
            if (initialized && window.ClearentSDK) {
                window.ClearentSDK.reset();
            }
            if (window.ClearentTokenSuccess === handleTokenSuccess) {
                window.ClearentTokenSuccess = previousTokenSuccess;
            }
            if (window.ClearentTokenError === handleTokenError) {
                window.ClearentTokenError = previousTokenError;
            }
        };
    }, [
        baseUrl,
        clearPaymentError,
        enableApplePay,
        enableGooglePay,
        markPaymentSubmitting,
        publicKey,
        sdkScriptUrl,
        reportProcessorError,
        walletAmount,
        walletMerchantLabel,
    ]);
    useEffect(function () {
        if (!avsIncomplete) {
            setAvsRequiredMessageVisible(false);
        }
    }, [avsIncomplete]);
    var handlePaymentFieldBlockedAttempt = useCallback(function (event) {
        if (!avsIncomplete) {
            return;
        }
        var target = event.target;
        if (target instanceof HTMLElement && target.closest(".radix-avs-collection-form")) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        setAvsRequiredMessageVisible(true);
        var zipCodeField = document.getElementById("avsZipCode");
        if (zipCodeField) {
            zipCodeField.focus();
        }
    }, [avsIncomplete]);
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var zipCodeField, result, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clearPaymentError();
                    if (avsIncomplete) {
                        setAvsRequiredMessageVisible(true);
                        zipCodeField = document.getElementById("avsZipCode");
                        if (zipCodeField) {
                            zipCodeField.focus();
                        }
                        return [2 /*return*/];
                    }
                    if (!window.ClearentSDK) {
                        reportProcessorError("xplorpay", {
                            code: "xplorpay_sdk_unavailable",
                            message: "The payment form is not ready yet. Please wait a moment and try again.",
                        });
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    markPaymentSubmitting(true);
                    manualTokenRequestPendingRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, window.ClearentSDK.getPaymentToken()];
                case 2:
                    result = _a.sent();
                    return [4 /*yield*/, processPaymentToken(result, shouldSaveCard)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    error_3 = _a.sent();
                    orderSubmissionStartedRef.current = false;
                    setIsSubmitting(false);
                    markPaymentSubmitting(false);
                    reportProcessorError("xplorpay", {
                        code: "xplorpay_token_error",
                        message: "The payment processor could not verify this payment method. Please try again.",
                    });
                    return [3 /*break*/, 6];
                case 5:
                    manualTokenRequestPendingRef.current = false;
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [
        avsIncomplete,
        clearPaymentError,
        markPaymentSubmitting,
        processPaymentToken,
        reportProcessorError,
        shouldSaveCard,
    ]);
    var paymentFormDisabled = isLoading || isSubmitting || !publicKey || avsIncomplete;
    return (React.createElement("div", { className: "radix-credit-payment-form radix-credit-payment-form--xplorpay", role: "region", "aria-label": "Payment details" },
        React.createElement(PaymentErrorNotice, { error: paymentError }),
        isLoading ? React.createElement(RadixLoading, { label: "Loading Payment Form" }) : null,
        isSubmitting ? React.createElement(RadixLoading, { label: "Processing payment" }) : null,
        React.createElement("div", { style: { display: isLoading || isSubmitting ? "none" : "block" } },
            avsRequiredMessageVisible ? (React.createElement("p", { className: "radix-error-message", role: "alert" }, "A valid billing ZIP code is required before entering payment information.")) : null,
            React.createElement("div", { onMouseDownCapture: handlePaymentFieldBlockedAttempt, onTouchStartCapture: handlePaymentFieldBlockedAttempt, onPointerDownCapture: handlePaymentFieldBlockedAttempt },
                React.createElement(PaymentForm, { id: XPLORPAY_FORM_ID, disabled: paymentFormDisabled, validatePaymentFields: false, orderSummaryNcaFeeDescription: getXplorPayDebitFeeDescriptor(processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.processor, sessionNcaTitle), savePaymentOption: {
                        checked: shouldSaveCard,
                        onCheckedChange: setShouldSaveCard,
                        label: "Save this card",
                        disabled: isLoading,
                    }, paymentFields: React.createElement("div", { id: XPLORPAY_PAYMENT_FORM_ID, className: "mt-2 w-100" }), onSubmit: handleSubmit },
                    React.createElement(AVSCollectionDetails, { onSubmit: function () { }, alwaysVisible: true, showAddress: false }))))));
};
